import { render, staticRenderFns } from "./Suicidal_Ideation.vue?vue&type=template&id=49dc492a&scoped=true&lang=pug&"
import script from "./Suicidal_Ideation.vue?vue&type=script&lang=ts&"
export * from "./Suicidal_Ideation.vue?vue&type=script&lang=ts&"
import style0 from "./Suicidal_Ideation.vue?vue&type=style&index=0&id=49dc492a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc492a",
  null
  
)

export default component.exports